export enum ImageResources {
  ONBOARDING = 'onboarding.png',
}
